import createPaletteEngine from './create-palette-engine';
import { camelCaseObjectToSnakeCase } from '../../utils/convert-case';
import { DEFAULT_SCHEME_PREFIX_MAP, CUSTOM_PALETTE_ID_PREFIX } from '../constants/color-schemes';

const extractSchemes = (flatVariables) => {
  const root = {};
  const schemes = {};
  const prefixEntries = Object.entries(DEFAULT_SCHEME_PREFIX_MAP);

  Object.entries(flatVariables).forEach(([key, value]) => {
    const match = prefixEntries.find(([, prefix]) => key.startsWith(`${prefix}_`));

    if (match) {
      const [schemeId, prefix] = match;
      if (!schemes[schemeId]) schemes[schemeId] = {};
      schemes[schemeId][key.slice(prefix.length + 1)] = value;
    } else {
      root[key] = value;
    }
  });

  return { root, schemes };
};

const compilePaletteIfNeeded = (palette) => {
  // default color palettes still have their own variables
  if (!palette.id.startsWith(CUSTOM_PALETTE_ID_PREFIX)) {
    return {
      ...palette,
      variables: extractSchemes(camelCaseObjectToSnakeCase(palette.variables)),
    };
  }

  const engine = createPaletteEngine(palette);
  return engine.getOutput();
};

export default compilePaletteIfNeeded;
